import { Button } from "@mui/material";


export const ButtonDefault = ({children,...rest}) => {
        return <Button {...rest}>{children}</Button>
}